import { EnumsValues } from '../../enums/EnumsValues';
import { FeatureFlagWrapper } from '../FeatureFlagWrapper/FeatureFlagWrapper';
import useFileUploader from '../../hooks/useFileUploader/useFileUploader';
import DocumentTable from '../../components/common/DocumentTable/DocumentTable';
import './DeliveryNotePage.less';
import { useRef, useEffect } from 'react';
import { ActionType } from '@ant-design/pro-table';

const DeliveryNotePage = () => {
  const { FileUploader, documentUploaded } = useFileUploader(
    EnumsValues.DocumentTypeEnum.DeliveryNote,
  );
  const actionRef = useRef<ActionType>();

  useEffect(() => {
    if (documentUploaded && actionRef.current?.reload) {
      actionRef.current.reload();
    }
  }, [documentUploaded]);

  return (
    <FeatureFlagWrapper
      featureFlag={EnumsValues.FeatureFlags.deliveryNotePage}
      publicAccess={false}
    >
      <div className="delivery-note-page">
        <FileUploader />
        <DocumentTable
          documentType={EnumsValues.DocumentTypeEnum.DeliveryNote}
          actionRef={actionRef}
          exportMapKey={EnumsValues.ExportReceiptHeadersMapKeys.DeliveryNote}
        />
      </div>
    </FeatureFlagWrapper>
  );
};

export default DeliveryNotePage;
